export default __webpack_public_path__ + "static/media/corporation.920ce82d.svg";